/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AbstractControl, FormArray, FormGroup} from '@angular/forms';
import {Animal} from '../../../_models/animal';
import {AnimalDetail} from '../../../_models/animal-detail';

@Component({
  selector: 'app-table-removal-animals',
  templateUrl: './table-removal-animals.component.html',
  styleUrls: ['./table-removal-animals.component.scss']
})
export class TableRemovalAnimalsComponent implements OnInit, OnChanges {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() controlName?: string;
  @Input() formGroup?: FormGroup;
  @Input() submitted?: boolean;

  @Output() updated = new EventEmitter<Animal[]>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    this.controlName = 'animals';
    this.formGroup = null;
    this.submitted = false;
  }

  ngOnInit() {
    // if (this.dataFA) {
    //   this.dataFA.valueChanges.subscribe(() => {
    //     this.updateControlsValidators();
    //   });
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORM CONTROLS GETTERS                                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get control(): AbstractControl | null {
    return this.formGroup ? this.formGroup.get(this.controlName) : null;
  }

  get dataFA(): FormArray | null {
    return this.formGroup ? this.formGroup.get(this.controlName) as FormArray : null;
  }

  public getNumberControl(fg: AbstractControl): AbstractControl | null {
    return fg ? fg.get('number') : null;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get animalGenderColDisplay(): boolean {
    const res = this.controls.filter((value) => value.value && value.value._embedded && value.value._embedded.animalGender);
    return 0 < res.length;
  }

  get animalNumberColDisplay(): boolean {
    const res = this.controls.filter((value) => {
      if (value.value && value.value._embedded && value.value._embedded.animalDetail) {
        return value.value._embedded.animalDetail.allowNumber && 1 === value.value.quantity;
      }

      return false;
    });
    return 0 < res.length;
  }

  get animalTypeColDisplay(): boolean {
    const res = this.controls.filter((value) => value.value && value.value._embedded && value.value._embedded.animalType);
    return 0 < res.length;
  }

  get autopsyColDisplay(): boolean {
    return 0 < this.controls.filter((value) => value.value && value.value.autopsy).length;
  }

  get controlId(): string {
    return `${this.controlName}ID`;
  }

  get controls(): AbstractControl[] {
    return this.dataFA && this.dataFA.controls ? this.dataFA.controls : [];
  }

  public getAnimalDetail(fg: AbstractControl): AnimalDetail | null {
    return (fg && fg.value && fg.value._embedded && fg.value._embedded.animalDetail) ? fg.value._embedded.animalDetail : null;
  }

  public getQty(fg: AbstractControl): number | null {
    return (fg && fg.value && fg.value.quantity) ? fg.value.quantity : 1;
  }

  public showNumberInput(fg: AbstractControl): boolean {
    return this.getAnimalDetail(fg) && this.getAnimalDetail(fg).allowNumber && 1 === this.getQty(fg);
  }

  // public updateControlsValidators() {
  //   if (this.dataFA) {
  //     this.controls.forEach((fg: FormGroup) => {
  //       const numberControl = this.getNumberControl(fg);
  //
  //       if (numberControl) {
  //         numberControl.setValidators(null);
  //         const detail = this.getAnimalDetail(fg);
  //         const qtyIs1 = 1 === this.getQty(fg);
  //
  //         if (detail && detail.allowNumber && qtyIs1) {
  //           const validators: ValidatorFn[] = [
  //             Validators.pattern(new RegExp(detail.numberRegex))
  //           ];
  //
  //           if (detail.needNumber) {
  //             validators.push(Validators.required);
  //           }
  //
  //           numberControl.setValidators(validators);
  //         }
  //
  //         numberControl.updateValueAndValidity({onlySelf: false, emitEvent: false});
  //       }
  //     });
  //   }
  // }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              CHANGE LISTENER                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public removeAnimal(i: number) {
    this.dataFA.removeAt(i);
  }

}
